import { defineMessages } from 'react-intl';

export const messages: {
	expandBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	expandBodyContent: {
		id: 'jsm-solution-composer-plan.task-card.card-content.expand-body-content',
		defaultMessage: 'Show more',
		description:
			'Button label to expand the card content area when text exceeds the visible height; one-way expand (no Show less)',
	},
});
